import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ToastService, ToastMessage } from '../services/toast.service';

@Component({
	selector: 'app-toast',
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="toast-container" *ngIf="toast">
			<div class="toast" [ngClass]="'toast-' + toast.type">
				{{ toast.message }}
			</div>
		</div>
	`,
	styles: [`
		.toast-container {
			position: fixed;
			top: 20px;
			left: 50%;
			transform: translateX(-50%);
			z-index: 10000;
			width: 25%;
			min-width: 250px;
			max-width: 400px;
		}

		.toast {
			padding: 15px 50px 15px 15px;
			border-radius: 3px;
			color: #fff;
			font-size: 14px;
			text-align: center;
			box-shadow: 0 0 12px #999999;
			opacity: 0.8;
			transition: opacity 0.2s, box-shadow 0.2s;
			animation: fadeIn 0.3s ease-in-out;
		}

		.toast:hover {
			opacity: 1;
			box-shadow: 0 0 12px #000000;
		}

		.toast-success {
			background-color: #51a351;
		}

		.toast-error {
			background-color: #bd362f;
		}

		.toast-warning {
			background-color: #f89406;
		}

		@keyframes fadeIn {
			from {
				opacity: 0;
				transform: translateY(-10px);
			}
			to {
				opacity: 0.8;
				transform: translateY(0);
			}
		}
	`]
})
export class ToastComponent implements OnInit, OnDestroy {
	private toastService = inject(ToastService);
	private subscription: Subscription | null = null;

	toast: ToastMessage | null = null;

	ngOnInit(): void {
		this.subscription = this.toastService.toast$.subscribe(toast => {
			this.toast = toast;
		});
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}
}
